import {
  Component,
  OnInit,
  ViewEncapsulation,
  Input,
  Output,
  EventEmitter,
  ViewChild,
  ElementRef,
  OnChanges,
  SimpleChanges,
} from "@angular/core";
import { UntypedFormControl } from "@angular/forms";
import { faSearch } from "@fortawesome/pro-light-svg-icons";
import { Store } from "@ngrx/store";
import { AppState } from "../../store/state/app.state";
import { debounceTime } from "rxjs/operators";
import { HttpClient } from "@angular/common/http";
import { Dictionary } from "src/app/store/models/common_types";
import { AppService } from "src/app/app.service";
import { VAIconRegistryService, search } from "@va/core-library/icons";

@Component({
  selector: "app-lineitem-search",
  templateUrl: "./lineitem-search.component.html",
  styleUrls: ["./lineitem-search.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class LineitemSearchComponent implements OnInit, OnChanges {
  @Input() industryName: string;
  //single ticker mode
  @Input() ticker: string;
  //multi ticker mode
  @Input() tickers: Array<string>;
  @Input() suggestedLines: Array<Dictionary<any>>;
  @Input() onScreen?: boolean;
  @Input() onModal?: boolean;
  @Input() pageName: string;
  @Input() totalLiAdded?: number = 0;
  @Input() disabled: boolean;
  @Input() placeholder = "Search Line Items";
  @Input() className = "";
  @Input() cascaderClassName = "";
  @Input() inputSize = "small";
  @Input() focusOnRender: boolean;
  // This array should not contain suggested line items
  @Input() stdLines: Array<Dictionary<any>>;
  // This is use to search and filter the standard line items without calling `search_lines` api.
  @Input() inMemoryFilterSearchForStd = false;
  @Input() maxCount = 50;
  // LIM modal need to have subset of line items,
  // so monitoring=true param is added to line item search call
  @Input() isLIMModal = false;
  // Unique Id for line item input element
  @Input() lineItemInputId = "cascader-input";
  @Output() callback: EventEmitter<any> = new EventEmitter();
  @Output() onClickTabName: EventEmitter<any> = new EventEmitter();
  @Output() onCascaderVisibilityChange: EventEmitter<any> = new EventEmitter();
  @Output() onLineItemInputChange: EventEmitter<any> = new EventEmitter();
  faSearch = faSearch;
  searchText = "";
  apiEP: string = window.apiUrl;
  // Adding input as a FormControl so that we can use the valueChanges method
  queryField: UntypedFormControl = new UntypedFormControl();
  isInitialized = false;

  options: any = [];
  nzOptions = this.options;
  values: string[] | null = null;
  hasContent = false;
  isCascaderVisible = false;

  constructor(
    private store: Store<AppState>,
    private http: HttpClient,
    private appService: AppService,
    private iconRegistry: VAIconRegistryService,
  ) {
    this.iconRegistry.registerIcons([search]);
  }

  @ViewChild("search") searchElement: ElementRef<HTMLElement>;

  /**
   * This method filters the searched results from std line items array.
   * This is useful for in-memory search and filter. This avoids calling `search_lines` api on every input change
   * This methods needs searchTerm and standard line item data, from which it should filter
   * @param searchTerm {string} search term to filter
   * @returns Array of object that contains given search term
   */
  getSTDSearchedResult(searchTerm: string) {
    const output = [];
    // const formattedLI = this.appService.formatStdLineItemsData(this.stdLines);
    const formattedSearchTerm = searchTerm && searchTerm.trim().toLowerCase();
    if (formattedSearchTerm && this.stdLines && this.stdLines.length) {
      const stdHeader = {
        disabled: true,
        header: true,
        isLeaf: true,
        label: "Standardized",
        level: 1,
      };
      for (const item of this.stdLines) {
        const currentChild = item.tab_sli_data;
        const tabLabel = item.tab_full_name;
        const tabId = item.tab_short_name;
        const searchedItems = [];
        if (tabId === "SL") {
          continue;
        }
        for (const childItem of currentChild) {
          const formattedTargetTerm = childItem.label.trim().toLowerCase();
          if (formattedTargetTerm.includes(formattedSearchTerm)) {
            searchedItems.push(childItem);
          }
        }

        const searchItemLength = searchedItems.length;
        if (searchItemLength) {
          const currentResult = {
            label: `${tabLabel} (${searchItemLength})`,
            tabshortname: tabId,
            disabled: this.totalLiAdded >= this.maxCount,
            children: [
              {
                label: tabLabel,
                isLeaf: true,
                disabled: true,
                header: true,
                level: 1,
              },
              ...searchedItems,
            ],
          };
          output.push(currentResult);
        }
      }

      if (output.length) {
        output.unshift(stdHeader);
      }
    }
    return output;
  }

  ngAfterViewInit() {
    if (this.focusOnRender) {
      setTimeout(() => {
        this.searchElement.nativeElement.focus();
      }, 500);
    }
  }

  ngOnInit() {
    this.queryField.valueChanges.pipe(debounceTime(500)).subscribe((text) => {
      this.onLineItemInputChange.emit(text);
      if (!this.isInitialized) {
        this.isInitialized = true;
      } else {
        this.getLineItemSearchData(text);
      }
    });

    // this.options.map((item)=>{
    //   if(item.children){
    //     let headerObj = {
    //       label: item.label,
    //       disabled: true,
    //       level: 1,
    //       header: true
    //     }
    //     item.children.unshift(headerObj);

    //     item.children.map((child)=>{
    //       child["isLeaf"] = true;
    //       child["value"] = child.label;
    //     })
    //     item["value"] = item.label;

    //     item.label = item.label + " (" + (item.children.length - 1) + ")";
    //   }else if (item.header){
    //     item["disabled"] = true;
    //     item["isLeaf"] = true;
    //     item["value"] = item.label;
    //   }
    // })

    // for(var i=0; i< this.lineItemsData.lineitems.length; i++){
    //   if(this.lineItemsData.lineitems[i].subheader.length > 0){
    //     var headerObj={
    //       "label":  this.lineItemsData.lineitems[i].header,
    //       // "value": this.lineItemsData.lineitems[i].header,
    //       "isLeaf": true,
    //       "disabled": true,
    //       "header": true,
    //       "level": 1
    //     }
    //     this.options.push(headerObj);
    //   }
    //   var level2Data : any = this.lineItemsData.lineitems[i].subheader;
    //   for(var l2Index=0; l2Index < level2Data.length; l2Index++){
    //         if(level2Data[l2Index].sname){
    //                 var level2Obj={
    //                     "label": level2Data[l2Index].sname,
    //                     // "value": level2Data[l2Index].sname,
    //                     "shortName": level2Data[l2Index].sshortname,
    //                     "isLeaf": true,
    //                     "disabled": true,
    //                     "header": true,
    //                     "level": 2
    //                 }
    //           this.options.push(level2Obj);
    //         }
    //     var level3Data : any = level2Data[l2Index].values;
    //     for(let l3Key in level3Data){
    //       var level3Obj: any = {
    //         "label": level3Data[l3Key].tabfullname,
    //         // "value": level3Data[l3Key].tabfullname,
    //         "level": 2
    //       }
    //       var convertedData = []
    //       for(let key in level3Data[l3Key].subvalues){
    //         var level4Obj={};
    //         level4Obj["id"] = key;
    //         level4Obj["label"] = level3Data[l3Key].subvalues[key];
    //         // level4Obj["value"] = level3Data[l3Key].subvalues[key];
    //         level4Obj["isLeaf"] = true;
    //         level4Obj["level"] = 3;
    //         convertedData.push(level4Obj)
    //             }
    //       level3Obj.children = convertedData;
    //       this.options.push(level3Obj);
    //     }
    //   }
    // }

    // console.log(JSON.stringify(this.options));
  }

  ngOnChanges(changes: SimpleChanges) {
    if (
      changes.stdLines &&
      changes.stdLines.currentValue !== changes.stdLines.previousValue &&
      this.inMemoryFilterSearchForStd
    ) {
      this.stdLines = [
        ...this.appService.formatStdLineItemsData(this.stdLines),
      ];
    }
  }

  inputClicked() {
    if (!this.disabled) {
      if (this.suggestedLines) {
        if (this.totalLiAdded >= this.maxCount) {
          if (this.pageName === "comps") {
            this.suggestedLines = this.suggestedLines.map((o) => {
              return {
                ...o,
                disabled: true,
              };
            });
          } else {
            this.suggestedLines = this.suggestedLines.map((o) => {
              return {
                ...o,
              };
            });
          }
        } else {
          this.suggestedLines = this.suggestedLines.map((o) => {
            return {
              ...o,
              disabled: o.suggestion_header || o.suggestion_footer,
            };
          });
        }
      }
      this.getLineItemSearchData(this.queryField.value);
    }
  }

  onChanges(value: string[]): void {
    const i = this.queryField.value ? 1 : 0;
    this.callback.emit([value[i]]);
    this.queryField.setValue("", { emitEvent: false });
    // this.searchText = "";
  }

  onVisibleChange(isVisible) {
    this.isCascaderVisible = isVisible;
    this.onCascaderVisibilityChange.emit(isVisible);
  }

  // onClickSearch(): void {
  //   // show suggested line items if input is blank
  //   if (!this.queryField.value && this.industryName) {
  //     this.nzOptions = this.suggestedLines;
  //     const cascaderEl: any = document.querySelector(
  //       ".ant-popover-inner-content #cascader-input"
  //     );
  //     cascaderEl.click();
  //   }
  // }

  getLineItemSearchData(text: string) {
    let isLIMModal = "";
    const lineItemPopover: any =
      document.getElementsByClassName("lineitem-search");
    // const cascaderEl: any = this.industryName
    //   ? document.querySelector(".ant-popover-inner-content #cascader-input")
    //   : this.onModal === true &&
    //     document.querySelectorAll("#cascader-input").length > 1
    //   ? document.querySelectorAll("#cascader-input")[1]
    //   : document.querySelector("#cascader-input");

    // Commenting above code, as with above approach, issue rises when there are multiple lineitem component on single screen, it selects the first input belonging to first line item.
    // To avoid this, implementing unique id to select the input
    const cascaderEl = document.getElementById(this.lineItemInputId);

    // api call here
    if (!text) {
      if (this.suggestedLines && this.suggestedLines.length > 0) {
        this.options = this.suggestedLines;
        this.nzOptions = this.options;
        if (lineItemPopover.length === 0 && cascaderEl) {
          cascaderEl.click();
        }
      } else {
        if (document.getElementsByClassName("ant-cascader-menus").length > 0) {
          cascaderEl.click();
        }
      }
    } else {
      if (
        lineItemPopover.length === 0 &&
        cascaderEl &&
        !this.isCascaderVisible
      ) {
        cascaderEl.click();
      }

      const noData: Array<object> = [
        {
          disabled: true,
          isLeaf: true,
          label: "No Results Found.",
          level: 2,
          info: true,
        },
      ];

      if (this.inMemoryFilterSearchForStd) {
        const inMemorySearchedData: Array<any> =
          this.getSTDSearchedResult(text) || [];
        this.hasContent = !!inMemorySearchedData.length;
        this.options = inMemorySearchedData.length
          ? inMemorySearchedData
          : noData;
        this.nzOptions = this.options;
        return;
      }

      let ticker = this.ticker ? `ticker=${this.ticker}` : "";
      let tickers =
        this.tickers && this.tickers.length ? this.getTickerParam() : "";
      const industryName = this.industryName
        ? `industry_name=${encodeURIComponent(this.industryName)}`
        : "";
      if (this.isLIMModal) {
        isLIMModal = "&monitoring=true";
        ticker = `&ticker=${this.tickers[0]}`;
        tickers = "";
      }
      this.http
        .get(
          `${
            this.apiEP
          }/api/search_lines?${industryName}${ticker}${tickers}${isLIMModal}&search_query=${encodeURIComponent(
            text,
          )}`, // add &monitoring=true here
        )
        .pipe(debounceTime(500))
        .subscribe((lineitemData: Array<any>) => {
          this.hasContent = !!lineitemData.length;
          if (this.onScreen === true && this.pageName === "comps")
            lineitemData.push({
              suggestion_footer: "Selected Line Items",
              isLeaf: true,
              disabled: true,
            });

          if (this.pageName === "comps") {
            noData.push({
              suggestion_footer: "Selected Line Items",
              isLeaf: true,
              disabled: true,
            });
          }
          if (this.pageName === "comps") {
            const data = lineitemData.map((obj) => {
              const objClone = JSON.parse(JSON.stringify(obj));
              objClone["disabled"] = "true";
              return objClone;
            });
            this.options = (
              this.onScreen ? lineitemData.length > 1 : lineitemData.length > 0
            )
              ? this.onScreen && this.totalLiAdded >= this.maxCount
                ? data
                : lineitemData
              : noData;
          } else {
            this.options = (
              this.onScreen ? lineitemData.length > 1 : lineitemData.length > 0
            )
              ? lineitemData
              : noData;
          }
          this.nzOptions = this.options;
        });
    }
  }

  lineItemSearchKeyChange(event: any, key: string): void {
    const lineItemPopover: any =
      document.getElementsByClassName("lineitem-search");
    if (key === "down" || key === "up" || key === "enter") {
      if (lineItemPopover.length !== 0) {
        setTimeout(() => {
          const firststItem: any = document.querySelector(
            ".ant-cascader-menu-item:not(.ant-cascader-menu-item-disabled)",
          );
          firststItem.click();
        }, 100);
      }
    }
  }

  onClickOption(param: any) {
    this.onClickTabName.emit(param);
  }
  getTickerParam(): string {
    let tckr = "tickers=";
    this.tickers.forEach((t, index) => {
      if (index > 0) {
        tckr = `${tckr}&tickers=`;
      }
      tckr = tckr + t;
    });
    return tckr;
  }

  resetSearchResults() {
    if (this.onScreen === true) {
      this.queryField.reset();
      this.options = [];
      this.nzOptions = this.options;
    }
  }
}
